let openInstallInstance = null;

export function initKszbOpenInstall(appKey, data = {}) {
  openInstallInstance = new OpenInstall(
    {
      appKey,
      onready: function () {
        this.schemeWakeup();
        return false;
      },
    },
    data
  );
}

export function kszbOpenInstallDownload() {
  if (openInstallInstance) {
    openInstallInstance.wakeupOrInstall();
  }
}
